import React from 'react';
import PropTypes from 'prop-types';
import colours from './Colours';
import { P3Bold } from './Text';

const fontColors = {
    request: colours.primary.grey01,
    confirmed: colours.primary.white,
    active: colours.primary.white,
    sent: colours.primary.white,
    outstanding: colours.primary.white,
    dismissed: colours.primary.white,

    cancelled: colours.primary.white,
    completed: colours.primary.white,
    booked: colours.primary.white,
    approved: colours.primary.white,
    pending: colours.primary.white,
    released: colours.primary.white,
    denied: colours.primary.white,
}

const backgroundColors = {
    request: colours.accent.caution_yellow,
    confirmed: colours.accent.validate_green,
    active: colours.primary.blue,
    sent: colours.accent.error_red,
    outstanding: colours.accent.error_red,
    dismissed: colours.primary.grey02,

    cancelled: colours.accent.error_red,
    booked: colours.primary.blue,
    released: colours.functional.pool_fleet,
    completed: '#001489',
    approved: colours.accent.validate_green,
    pending: colours.primary.grey02,
    denied: colours.accent.error_red,
}

const labels = {
    request: "Request",
    confirmed: "Confirmed",
    active: "Active",
    sent: "Sent",
    outstanding: "Outstanding",
    dismissed: "Dismissed",

    // Graphql booking status
    cancelled: 'Cancelled',
    completed: 'Completed',
    booked: 'Booked',
    approved: 'Approved',
    pending: 'Pending',
    released: 'Released',
    denied: 'Denied',
}

const Chip = (props) => {
    if (props.type) {
        return (
            <div style={{
                backgroundColor: backgroundColors[props.type],
                padding: '4px 8px',
                borderRadius: '16px',
                minWidth: '78px',
                textAlign: 'center'
                }}>
                    <P3Bold style={{color: fontColors[props.type], textTransform: 'capitalize'}}>{labels[props.type]}</P3Bold>
            </div>
        )
    } else if (props.custom) {
        return (
            <div style={{
                backgroundColor: props.custom.backgroundColor,
                padding: '4px 8px',
                borderRadius: '16px',
                minWidth: '78px',
                textAlign: 'center'
                }}>
                    <P3Bold style={{color: props.custom.fontColor, textTransform: 'capitalize'}}>{props.custom.label}</P3Bold>
            </div>
        )
    } else {
        return null;
    }
}

Chip.defaultProps = {
    type: '',
    custom: null
};

Chip.propTypes = {
    type: PropTypes.oneOf(Object.keys(labels)),
    custom: PropTypes.shape({
        backgroundColor: PropTypes.string,
        fontColor: PropTypes.string,
        label: PropTypes.string
    })
}

export default Chip;